<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="rectWidth1" colspan="13" class="border-right">第一位</th>
          <th ref="rectWidth2" colspan="13" class="border-right">第二位</th>
          <th ref="rectWidth3" colspan="13" class="border-right">第三位</th>
          <th ref="rectWidth4" colspan="13" class="border-right">第四位</th>
          <th colspan="13" class="border-right">第五位</th>
          <th colspan="13" class="border-right">号码分布</th>
          <th colspan="3" rowspan="2" class="border-right border-bottom">单双比</th>
          <th colspan="3" rowspan="2" class="border-bottom border-right">中位数</th>
        </tr>
        <tr class="title-number">
          <template v-for="i in 6">
          <th class="ball-none border-bottom-header" :key="i + 'left'"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num' + i + 'center'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th :key="i + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-for="(everyNumTrend, entindex) in openNumSperateTrendList">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none" :key="entindex + 'left'"></td>
            <td class="df-trendchart-11X5-tdsize" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'center' + nindex" v-for="(num, nindex) in everyNumTrend[index]">
              <i class="ball-noraml openNo" v-if="num === 'A'">{{ lotteryNumbHead[nindex] }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="entindex + 'right'" class="ball-none border-right"></td>
          </template>
          <!-- 号码分布 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="ontindex + 'opendNumTableList'" v-for="(num, ontindex) in opendNumTableList[index]">
            <i class="ball-noraml openNo-1" v-if="num === 'A'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-2" v-else-if="num === 'B'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml openNo-3" v-else-if="num === 'C'">{{ lotteryNumbHead[ontindex] }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <!-- 单双比 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" colspan="3" class="ball-none _bili border-right">
            <i class="ball-noraml">{{dsb[index]}}</i>
          </td>
          <!-- 中位数 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><i class="ball-noraml">{{centerNum[index]}}</i></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
        </tr>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList&&lotteryTrendList.length > 0">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left1' + 'count'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center2' + sindex + 'count'" v-for="(count, sindex) in single.countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td :key="index + 'right3' + 'count'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(count, sindex) in openNumStatisticaList.countArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'averageMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'averageMiss'" v-for="(averageMiss, sindex) in single.averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td :key="index + 'right' + 'averageMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(averageMiss, sindex) in openNumStatisticaList.averageMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'maxMiss'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxMiss'" v-for="(maxMiss, sindex) in single.maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td :key="index + 'right' + 'maxMiss'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxMiss, sindex) in openNumStatisticaList.maxMissArr" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-for="(single, index) in openNumSperateStatisticaList">
            <td :key="index + 'left' + 'maxContinuity'" class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="index + 'center' + sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in single.maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td :key="index + 'right' + 'maxContinuity'" class="ball-none border-right border-bottom"></td> 
          </template>
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" v-for="(maxContinuity, sindex) in openNumStatisticaList.maxContinuity" :key="sindex + 'averageMiss'">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td> 
          <td colspan="1" class="border-bottom dxxintai">
            <i class="ball-noraml"></i></td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  name: 'ElevenChart',
  mixins: [mix],
  computed: {
    // 中位数
    centerNum() {
      let arr = []
      this.openNumbArr.forEach((numArr, index) => {
        numArr.sort((a, b) => parseInt(a) - parseInt(b))
        arr[index] = numArr[2]
      })
      return arr
    }
  },
  mounted() {
    this.$nextTick((e) => {
      console.log('创建了')
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArrayCanvas();
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      console.log(69999999999999);
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArrayCanvas();
        }, 0);
      });
    });
  },
  methods: {
    getArrayChartCoordinate(Coordinate) {
        if (!this.$refs.drawnumbHead) return [];
        let chartCoordinate = [];

        Coordinate.forEach((trendList, trendIndex) => {
          //获取坐标系
          let len = trendList.length;
          if (len == 0) return [];

          //先获取表格左边不需要折线部分的宽度
          let dwidth = this.$refs.drawnumbHead.offsetWidth;
          let pwidth = this.$refs.periodsHead.offsetWidth;
          //左边总宽度
          let leftCountWidth = dwidth + pwidth;
          //上边总高度
          let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
          // 大格子宽度
          let rectWidth1 = this.$refs.rectWidth1.offsetWidth;
          let rectWidth2 = this.$refs.rectWidth2.offsetWidth;
          let rectWidth3 = this.$refs.rectWidth3.offsetWidth;
          let rectWidth4 = this.$refs.rectWidth4.offsetWidth;
          //表格td宽度 表格td高度
          if(!document.getElementById("smallRect")) {
            return;
          }
          const tdWidth = document.getElementById("smallRect").offsetWidth;
          const tdHeight = document.getElementById("smallRect").offsetHeight;

          let list = [];

          for (let i = 0; i < len; i++) {
            let numb = Number(this.lotteryNumbHead[trendList[i].indexOf("A")]);
            let index = this.lotteryNumbHead.indexOf(numb);
            let x
            if(trendIndex === 0) {
              x = leftCountWidth + 5 + (tdWidth * index + ( tdWidth / 2))
            }
            if(trendIndex === 1) {
              x = leftCountWidth + 5 + rectWidth1 + (tdWidth * index + ( tdWidth / 2))
            }
            if(trendIndex === 2) {
              x = leftCountWidth + 5 + rectWidth1 + rectWidth2 + (tdWidth * index + ( tdWidth / 2))
            }
            if(trendIndex === 3) {
              x = leftCountWidth + 5 + rectWidth1 + rectWidth2 + rectWidth3 + (tdWidth * index + ( tdWidth / 2))
            }
            if(trendIndex === 4) {
              x = leftCountWidth + 5 + rectWidth1 + rectWidth2 + rectWidth3 + rectWidth4 + (tdWidth * index + ( tdWidth / 2))
            }
            let y = topCountWidth + (tdHeight * i + tdHeight / 2);
            list.push([x, y]);
          }
          chartCoordinate.push(list);
        });

        return chartCoordinate;
      },
  }
}
</script>

<style>
@media screen and (max-width: 1920px) {
  .df-trendchart-11X5-tdsize {
    width:23px;
    height:35px;
  }
}
@media screen and (max-width: 1370px) {
  .df-trendchart-11X5-tdsize {
    width:16px;
    height: 35px;
  }
}
@media screen and (max-width: 1300px) {
  .df-trendchart-11X5-tdsize {
    width:16px;
    height: 35px;
  }
}
</style>